
  <span class="logo cc-logo">
      <span class="logo-img out"></span>
      <div>
    </div>
  </span>
